import { CompareBar } from './compareBar';
import { CompareButton } from './compareButton';
import { CompareModal } from './compareModal';
import { CompareProvider } from './compareProvider';
import { CompareToggle } from './compareToggle';

export type { CompareProduct } from './compareProvider';

export { MAX_COMPARE, useCompare } from './compareProvider';

export const CompareProducts = Object.assign(CompareProvider, {
  Bar: CompareBar,
  Button: CompareButton,
  Modal: CompareModal,
  Toggle: CompareToggle,
});
